<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading" id="acknowledgments">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ACKNOWLEDGMENTS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="acknowledgments-text">
<p class="first first-in-chapter first-full-width">To my family brother, Donald Wesley: for always being the person that I could turn to during my darkest times and years of despair. Your words of wisdom gave me the strength to pick myself up every time I fell. To my mother, the Late Lillie Johnson: for giving birth to me and instilling the importance of education. I love you, and we did this book together. To my daughters Laura and Faye: for being understanding and supportive as I pursued my dreams. Thank you for loving me even when my work and ambitions took me away from spending quality time with you. To my granddaughter, Nala: for being my inspiration to leave you a legacy. I can’t wait to see what God has planned for you. My unborn grandchildren: I love you. Status quo will no longer be acceptable because all your aspirations need is your determination and wiliness to pursue.</p>
<p class="subsq">My family and friends: Your love encouraged me to push past my fears and taught me that the only limitations I have in my life are the ones I create for myself. You guys have taught me to take the limits off my life, and you opened my heart to believe in myself again.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width">My Bestie for LIFE: Antoinette Martin: Thank you for being my biggest support and confidant.</p>
<p class="subsq">A special thanks to Lissa Woodson (Naleighna Kai) the Book Whisperer, who inspired me to join the 30-Day Writing Challenge. Thank you for providing guidance through the book writing process. To J. L. Woodson, thank you for your creative insights in developing my cover. I am also grateful to my editors, J. L. Campbell &amp; Christine Pauls, for helping me to keep my author’s voice through the editing process. Thank you to the Tribe of writers for becoming my support system and my second family. It is because of the Tribe’s combined efforts and encouragement that I have a living and breathing legacy that is now shared with the world.  Anita Roseboro-Wade you have been an awesome accountability partner and friend.</p>
<p class="subsq">Finally, to all those who have been a part of my getting to this point: I love you more than words can express. I appreciate all my family and friends who have spoken words of blessings over my life.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?d5721bee